import { content } from "../../config/content.js";
import { buildAnimatedHeading } from "../HeroTitleAnimation.js";
import { buildSectionPill } from "../components/SectionPill.js";

const starIcon = `<svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor" aria-hidden="true">
  <path d="M7 0.5l1.9 4.1 4.5 0.5-3.3 3 0.9 4.4L7 10.3 3 12.5l0.9-4.4-3.3-3 4.5-0.5L7 0.5z"/>
</svg>`;

function reviewCard(item) {
  return `
    <article class="review-card">
      <div class="review-card__rating">
        <span class="review-card__stars">★★★★★</span>
        <span class="review-card__score">${item.rating}</span>
      </div>
      <p class="review-card__quote">“${item.quote}”</p>
      <footer class="review-card__author">
        <span class="review-card__avatar">${item.initials}</span>
        <div>
          <strong>${item.name}</strong>
          <span>${item.role}</span>
        </div>
      </footer>
    </article>
  `;
}

export function createTestimonialsSection({
  data = content.testimonials,
  id = "testimonials",
} = {}) {
  const section = document.createElement("section");
  section.id = id;
  section.className = "section testimonials";

  const cards = data.items.map(reviewCard).join("");

  section.innerHTML = `
    <div class="section__inner testimonials__layout">
      <div class="testimonials__copy reveal">
        ${buildSectionPill(`
          ${data.badgePre}
          <span class="testimonials__badge-brand">${starIcon}${data.badgeBrand}</span>
        `)}
        <h2>${buildAnimatedHeading(data.titleSegments)}</h2>
        <p>${data.subtitle}</p>
      </div>
      <div class="testimonials__marquee reveal" style="--delay: 0.15s">
        <div class="testimonials__track">
          ${cards}
          ${cards}
        </div>
      </div>
    </div>
  `;

  return section;
}
